// eslint-disable-next-line import/prefer-default-export
export const API_URL = 'https://cms.howdesign.com.tw';
